
export default function RecentTransfers() {
  const transfers = [
    {
      id: 'TXN001',
      recipient: 'أحمد محمد علي',
      amount: '5,000',
      currency: 'ر.س',
      status: 'مكتمل',
      date: 'اليوم 14:30',
      type: 'sent',
      commission: '50'
    },
    {
      id: 'TXN002',
      recipient: 'فاطمة أحمد',
      amount: '2,500',
      currency: 'ر.س',
      status: 'قيد المعالجة',
      date: 'اليوم 12:15',
      type: 'sent',
      commission: '25'
    },
    {
      id: 'TXN003',
      recipient: 'محمد عبدالله',
      amount: '8,200',
      currency: 'ر.س',
      status: 'مكتمل',
      date: 'أمس 16:45',
      type: 'received',
      commission: '82'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'مكتمل': return 'text-green-600 bg-green-50';
      case 'قيد المعالجة': return 'text-orange-600 bg-orange-50';
      case 'مرفوض': return 'text-red-600 bg-red-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800">التحويلات الأخيرة</h3>
        <button className="text-blue-600 text-sm font-medium">
          عرض الكل
          <i className="ri-arrow-left-line mr-1"></i>
        </button>
      </div>
      
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {transfers.map((transfer, index) => (
          <div key={transfer.id} className={`p-4 ${index !== transfers.length - 1 ? 'border-b border-gray-100' : ''}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  transfer.type === 'sent' ? 'bg-red-50' : 'bg-green-50'
                }`}>
                  <i className={`${
                    transfer.type === 'sent' ? 'ri-arrow-up-line text-red-600' : 'ri-arrow-down-line text-green-600'
                  } text-lg`}></i>
                </div>
                <div>
                  <p className="font-medium text-gray-800">{transfer.recipient}</p>
                  <p className="text-xs text-gray-600">{transfer.date}</p>
                </div>
              </div>
              
              <div className="text-left">
                <p className="font-bold text-gray-800">
                  {transfer.type === 'sent' ? '-' : '+'}{transfer.amount} {transfer.currency}
                </p>
                <div className="flex items-center space-x-2 space-x-reverse mt-1">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(transfer.status)}`}>
                    {transfer.status}
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1">عمولة: {transfer.commission} ر.س</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
